import React, { Component } from 'react';
import DesktopNewDesign from './desktopNewDesign';

class CategoryNav extends Component<any, any> {
  public render() {
    return <DesktopNewDesign {...this.props} />;
  }
}

export default CategoryNav;
